import { useQuery } from '@tanstack/react-query'
import { Link, Spinner, Text } from '@viapeople/components'
import { Outlet } from 'react-router-dom'
import { useFeatureFlag } from '../../hooks/useFeatureFlag'
import { trpc } from '../../utils/trpc'

export const ReportsSidebar = () => {
	const { isEnabled: isReportBuilderEnabled } = useFeatureFlag('report-builder')
	const { isEnabled: isLeadershipDashboardEnabled } = useFeatureFlag('leadership-dashboard')

	const { data: reportsAccess, isLoading } = useQuery({
		...trpc.client.reports.getReportsAccess.queryOptions(),
	})
	const isAdmin = reportsAccess?.isAdmin ?? false
	const isManager = reportsAccess?.isManager ?? false

	return (
		<div className='flex w-full h-full'>
			<div
				data-testid='reports-sidebar'
				className='p-6 pl-4 pr-2 w-55 h-full overflow-hidden flex-shrink-0 border-r border-neutral-200'>
				{isLoading ? (
					<div data-testid='reports-sidebar-loading' className='flex justify-center items-center h-full'>
						<Spinner />
					</div>
				) : (
					<>
						{isAdmin && (
							<>
								<Text
									data-testid='reports-sidebar-admin-status-section'
									variant='hint'
									className='mb-2 text-neutral-500'>
									As Administrator (Status)
								</Text>
								<Link
									data-testid='reports-sidebar-link-status-overview'
									href='/reports/status-overview'
									variant='breadcrumb'
									className='hover:bg-neutral-100 rounded-md p-2 cursor-pointer w-full'>
									<Text variant='xsmall' weight='semibold'>
										Status Overview
									</Text>
								</Link>

								<Text data-testid='reports-sidebar-admin-section' variant='hint' className='mt-6 mb-2 text-neutral-500'>
									As Administrator
								</Text>
								<Link
									data-testid='reports-sidebar-link-generate-pdf'
									href='/reports/detailed-data-reports'
									variant='breadcrumb'
									className='hover:bg-neutral-100 rounded-md p-2 cursor-pointer w-full'>
									<Text variant='xsmall' weight='semibold'>
										Generate PDF
									</Text>
								</Link>
								<Link
									data-testid='reports-sidebar-link-detailed-status'
									href='/reports/employee-status-table'
									variant='breadcrumb'
									className='hover:bg-neutral-100 rounded-md p-2 cursor-pointer w-full'>
									<Text variant='xsmall' weight='semibold'>
										Detailed Status Reports
									</Text>
								</Link>
								<Link
									data-testid='reports-sidebar-link-manage-pdfs'
									href='/reports/manage-pdfs'
									variant='breadcrumb'
									className='hover:bg-neutral-100 rounded-md p-2 cursor-pointer w-full'>
									<Text variant='xsmall' weight='semibold'>
										Manage PDFs
									</Text>
								</Link>
								{isReportBuilderEnabled && (
									<Link
										data-testid='reports-sidebar-link-report-builder'
										href='/reports/report-builder'
										variant='breadcrumb'
										className='hover:bg-neutral-100 rounded-md p-2 cursor-pointer w-full'>
										<Text variant='xsmall' weight='semibold'>
											Report Builder
										</Text>
									</Link>
								)}
								{isLeadershipDashboardEnabled && (
									<Link
										data-testid='reports-sidebar-link-leadership-dashboard'
										href='/reports/leadership-dashboard'
										variant='breadcrumb'
										className='hover:bg-neutral-100 rounded-md p-2 cursor-pointer w-full'>
										<Text variant='xsmall' weight='semibold'>
											Leadership Dashboard
										</Text>
									</Link>
								)}
							</>
						)}
						{isManager && (
							<>
								<Text
									data-testid='reports-sidebar-manager-section'
									variant='hint'
									className={`${isAdmin ? 'mt-6' : ''} mb-2 text-neutral-500`}>
									As Manager
								</Text>
								<Link
									data-testid='reports-sidebar-link-manager-pdfs'
									href='/reports/manager-pdfs'
									variant='breadcrumb'
									className='hover:bg-neutral-100 rounded-md p-2 cursor-pointer w-full'>
									<Text variant='xsmall' weight='semibold'>
										My Team PDFs
									</Text>
								</Link>
							</>
						)}
					</>
				)}
			</div>
			<div className='flex-1 pb-10 overflow-auto'>
				<Outlet />
			</div>
		</div>
	)
}
